import { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import { MdOutlineKeyboardBackspace } from 'react-icons/md';

type AdminPageHeaderProps = {
  title: string;
  backToListLink?: string;
  backLinkText?: string;
};

export const AdminPageHeader = ({
  title,
  backToListLink,
  backLinkText,
  children,
}: PropsWithChildren<AdminPageHeaderProps>) => {
  return (
    <>
      {!!backToListLink && (
        <Link to={backToListLink} className="flex items-center gap-2 text-base-5">
          <MdOutlineKeyboardBackspace size={18} />
          <span className="text-s-sb">{backLinkText || 'Back to list'}</span>
        </Link>
      )}
      <div className="flex justify-between items-center gap-6">
        <h1 className="shrink-0">{title}</h1>
        {!!children && <div className="flex justify-end items-center gap-2 grow">{children}</div>}
      </div>
    </>
  );
};
